import { createAction } from 'typesafe-actions';

import { SetAppPagePayload } from './appPage.types';

export const setAppPage = createAction('SET_APP_PAGE')<SetAppPagePayload>();
